








































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { formRules } from '@/common/util/validator';
import { Toast } from 'vant'; 
import  dialogPanel  from "./dialogPanel.vue"
import { TbGoodsClass } from "@/http";
 @Component({
    components: {dialogPanel},
}) 
export default class addClassPanel extends Vue {
   
    public $refs!: {
       
    };

    @Prop({
        default:false
    })
    show:Boolean;
    @Prop({
        default:true
    })
    isParent:Boolean;
    @Prop({
        default:true
    })
    needJk:Boolean;
    @Prop({
        default:true
    })
    needSaveAdd:Boolean;

 
    title="新增分类";

    isloading=false;
    isloading2=false;

    childList = [];

    form={
        fname:"",
        sname:"",
        parentId:"",
        sort:0, 
    }
    initForm:any={};

    isFadd = true;
    parentId = "";


    async mounted() {
        
    }
    async created() {
    
    }

    init(item){
        this.initForm = item;
        this.form.parentId =item.id;
        this.form.fname = item.name; 
        this.form.sort = item.sort;
        this.childList = item.items;
        this.isFadd = false;
        this.parentId = item.id;
    }
    init1(val){
        console.log('this.isParent',val);
        if(val) {
            this.$nextTick(() => {
                $("#input1").focus();
            });
        }else {
            this.$nextTick(() => {
                $("#input2").focus();
            });
        }
    }

    async saveFun(val){
        if(!this.form.fname){
            Toast("请输入一级分类");
            return;
        }
        if(!this.isParent&&!this.form.sname){
            Toast("请输入二级分类");
            return;
        }
        
        if(this.needJk){
            if(this.isloading) return;
            this.isloading = true;
            if(this.isFadd){
                try {
                    let res = await TbGoodsClass.PostTbGoodsClass({
                        name:this.isParent?this.form.fname:this.form.sname,
                        isParent:this.isParent,
                        parentId:this.isParent?'':this.form.parentId,
                        child:this.isParent&&this.form.sname?{name:this.form.sname,isParent:false}:null,
                        sort:this.form.sort,
                    })
                    this.isloading = false;
                    Toast("新增成功")
                    if(val){
                        this.closeFun();
                        this.resetForm();
                    }else{
                        this.isFadd = false;
                        this.resetForm2();
                        this.parentId = res.id;
                    }
                    this.$emit("confirmSave",res);
                } catch (error) {
                    this.isloading = false;
                }
                
            }else{
                try {
                    let resC = await TbGoodsClass.GetTbGoodsClassByIsParent({isparent:false,parentid:this.parentId})
                    let childList = resC;
                    childList.unshift({
                        id:'',
                        name:this.form.sname,
                        sort:0,
                        updateType:1
                    })
                    childList = childList.map((v,index)=>{
                    return {
                        id:v.id,
                        name:v.name,
                        sort:index+1,
                        updateType:v.updateType?v.updateType:2,
                    }
                })
                    
                    let res = await TbGoodsClass.PutTbGoodsClass({
                        name:this.form.fname,
                        id:this.parentId,
                        sort:0,
                        updateType:2,
                        childList:childList
                    })
                    this.isloading = false;
                    Toast("新增成功")
                    let resC2 = await TbGoodsClass.GetTbGoodsClassByIsParent({isparent:false,parentid:this.parentId})
                    let resform = resC2.find(v=>v.name==this.form.sname);
                    let newResform = Object.assign({},resform,{
                        id:this.parentId,
                        childId:resform.id,
                    })
                    if(val){
                        this.closeFun();
                        this.resetForm();
                    }else{
                        this.resetForm2();
                    }
                    this.$emit("confirmSave",newResform);
                } catch (error) {
                    this.isloading = false;
                }
            }
        }else{
            let resC = await TbGoodsClass.GetTbGoodsClassByIsParent({isparent:false,parentid:this.form.parentId})
            let childList = resC;
            childList.unshift({
                id:'',
                name:this.form.sname,
                sort:0,
                updateType:1
            })
            childList = childList.map((v,index)=>{
            return {
                id:v.id,
                name:v.name,
                sort:index+1,
                updateType:v.updateType,
            }
        })

            try {
                let res =await TbGoodsClass.PutTbGoodsClass({
                    id:this.form.parentId,
                    name:this.form.fname,
                    sort:0,
                    updateType:2,
                    childList:childList
                })
                await this.$emit("confirmAdd",this.form);
                if(val){
                    await this.resetForm();
                    await this.$emit("closeFun");
                }else{
                    await this.resetForm2();
                }
                this.$emit('confirmSave');
            } catch (error) {
                
                await this.resetForm2();
                this.$emit('confirmSave');
            }
        }
    }
    resetForm(){
       this.form={
            fname:"",
            sname:"",
            parentId:"",
            sort:0,
       } 
       this.isFadd = true;
    }
    resetForm2(){
       this.form.sname="";
       this.form.sort=0; 
    }
    closeFun(){
        this.resetForm();
        this.$emit("closeFun");
    }
    resetInit(){
        this.form.parentId =this.initForm.id;
        this.form.fname = this.initForm.name; 
        this.form.sort = this.initForm.sort;
        this.childList = this.initForm.items;
    }

}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/components/pad/addClassPanel.vue